import { Routes } from '@angular/router';
import { DataResolver } from './app.resolver';
import { AuthGuard } from './shared/auth/auth-guard.service';
import { HomeComponent } from './home';
import { LoginComponent } from './login';
import { NoContentComponent } from './no-content';
import { MassiveActionsGuard } from './massive-actions/shared/massive-actions.guard';
import { HistoryGuard } from './history/history.guard';
import { OfficeGuard } from './office/office.guard';
import { TpaGuard } from './tpa/tpa.guard';

export const ROUTES: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'unauthorized', component: LoginComponent },
  { path: 'unauthorized/:returnUrl', component: LoginComponent },
  {
    path: 'office',
    loadChildren: () => import('./office/office.module').then(m => m.OfficeModule),
    canActivate: [AuthGuard, OfficeGuard],
  },
  { path: 'tpa', loadChildren: () => import('./tpa/tpa.module').then(m => m.TpaModule), canActivate: [AuthGuard, TpaGuard] },
  {
    path: 'settings',
    loadChildren: () => import('./settings/settings.module').then(m => m.SettingsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'history',
    loadChildren: () => import('./history/history.module').then(m => m.HistoryModule),
    canActivate: [AuthGuard, HistoryGuard],
  },
  {
    path: 'massive-actions',
    loadChildren: () => import('./massive-actions/massive-actions.module').then(m => m.MassiveActionModule),
    canActivate: [AuthGuard, MassiveActionsGuard],
  },
  { path: '**', component: NoContentComponent },
];
